import "./../App.css";
import "./../AppMobile.css";

import React from "react";
import { hideProcess, setLocaleApp, showProcess } from "./../utils/util";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import authenticateService from "../services/authenticateService";
import accountService from "../services/accountService";

export default class Terms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {}

    render() {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                }}
                onClick={() => this.props.onHide()}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        backgroundColor: "#fff",
                        padding: "20px",
                        borderRadius: "8px",
                        width: "90%",
                        maxWidth: "500px",
                        maxHeight: "80vh",
                        overflowY: "auto",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        textAlign: "justify",
                        color: "#333",
                    }}
                >
                    <h2 style={{ textAlign: "center", color: "#411172" }}>Termos de Uso</h2>
                    <h2>TERMOS DE USO E POLÍTICA DE PRIVACIDADE</h2>

                    <h3>TERMOS E CONDIÇÕES DE USO</h3>

                    <p>
                        Bem-vindo ao Enterative, um aplicativo mobile que torna possível a
                        comercialização e ativação dos melhores conteúdos digitais, nas modalidades
                        Online (Voucher) e Cartão Físico. Este acordo representa o contrato, como um
                        todo, entre você e a Enterative Ltda, e dessa forma, visitando, fazendo o
                        download do nosso aplicativo, você concorda, sem restrições, em aceitar os
                        termos e condições de uso abaixo indicados, uma vez que as disposições
                        constantes do presente Termo de Uso vinculam o usuário do aplicativo móvel
                        Enterative, externam nossa política de privacidade na divulgação de seu
                        conteúdo e protege o software e a marca, de acordo com as disposições das
                        Leis Federais n. 9.609/98 e 9.279/96.
                    </p>

                    <h4>1. Aceite dos termos</h4>

                    <p>
                        Pelo cadastramento, o Usuário ou Estabelecimento, independente de utilizar
                        ou não o serviço, aceita, sem limitação ou qualificação, as previsões da
                        presente Política de Privacidade e Termos de Uso, obrigando-se perante estas
                        condições. Ainda, pelo cadastramento, o Usuário ou Estabelecimento declara
                        ser juridicamente capaz ou estar legalmente representado para aderir e se
                        vincular à presente Política de Privacidade e Termos de Uso. Caso esteja
                        agindo em nome de uma pessoa jurídica, declara ter legitimidade, bem como,
                        poderes suficientes para aderir e vincular tal pessoa jurídica à presente
                        Política de Privacidade e Termos de Uso.
                    </p>

                    <p>
                        O cadastro como Usuário e/ou Estabelecimento não deve ser efetuado por
                        qualquer pessoa que não esteja de acordo com o disposto nesta Política de
                        Privacidade e Termos de Uso. Caso o Usuário e/ou o Estabelecimento não
                        concorde com as alterações, deverá cancelar sua conta e cessar toda e
                        qualquer utilização do Aplicativo. A Enterative Ltda pode modificar ou
                        atualizar esta Política de Privacidade e Termos de Uso a qualquer momento e
                        sem aviso prévio, portanto, revise-a periodicamente. A simples utilização do
                        aplicativo após qualquer atualização/modificação desta Política de
                        Privacidade e Termos de Uso constitui aceitação e concordância com a versão
                        mais recente. Caso não concorde com todos os termos, não use este site e não
                        faça download do nosso aplicativo.
                    </p>

                    <h4>2. Termos de Uso</h4>

                    <h5>2.1. Cadastro</h5>
                    <p>
                        Os Usuários ou Estabelecimentos que desejam utilizar o Aplicativo precisam
                        obrigatoriamente preencher os campos de cadastro e fornecer informações
                        verdadeiras, válidas e corretas. Alguns dados poderão ser confirmados pela
                        equipe da Enterative Ltda, especialmente a legitimidade/capacidade de
                        representação do responsável pelo cadastro dos Estabelecimentos.
                    </p>

                    <h5>2.2. Objeto</h5>
                    <p>
                        O Enterative consiste em uma plataforma para iOS e Android, um aplicativo
                        mobile que torna possível a comercialização e ativação dos melhores
                        conteúdos digitais, nas modalidades Online (Voucher) e Cartão Físico, bem
                        como o pagamento das compras realizadas, através de meio eletrônico ou
                        físico, conforme a disponibilidade anunciada na tela do próprio aplicativo.
                    </p>

                    <h5>2.3. Limitações de Responsabilidade</h5>
                    <p>
                        O Enterative não se responsabiliza pelo conteúdo publicado pelos
                        Estabelecimentos e/ou Usuários e se coloca no direito de excluir ou limitar
                        a publicação de qualquer material que, entre outras situações: (a) não
                        corresponda com o objetivo do aplicativo; (b) contenha dados e/ou
                        informações inverídicas; (c) possua conteúdo protegido por registro; (d)
                        possua qualquer conteúdo ilícito; (e) promova qualquer tipo de preconceito
                        ou discriminação; (f) afronte a moral ou os bons costumes.
                    </p>

                    <h5>2.4. Propriedade Intelectual</h5>
                    <p>
                        As marcas, nomes, logotipos, nomes de domínio e demais sinais distintivos,
                        bem como todo e qualquer conteúdo, desenho, arte ou layout publicado no
                        Aplicativo, são de propriedade exclusiva da CHART CONSULTORES EM INFORMÁTICA
                        LTDA, empresa desenvolvedora da plataforma e/ou suas controladas/coligadas,
                        embora não possua responsabilidade sobre as informações captadas e
                        arquivadas pela Enterative Ltda, que atenderá política de segurança da
                        informação própria da empresa que disponibiliza o aplicativo aos seus
                        clientes.
                    </p>
                    <p>
                        Nada contido no Aplicativo deve ser interpretado como concessão, por
                        inferência, ou caducidade, ou qualquer outra forma, de licença ou direito de
                        uso de qualquer marca comercial exibida. São vedados quaisquer atos ou
                        contribuições tendentes à modificação das características, ampliação,
                        alteração, mesclagem ou incorporação em quaisquer outros programas ou
                        sistemas. Enfim, toda e qualquer forma de reprodução, total ou parcial,
                        permanente, temporária ou provisória, de forma gratuita ou onerosa, sob
                        quaisquer modalidades, formas ou títulos dos Aplicativos, sem a prévia e
                        expressa autorização da CHART CONSULTORES EM INFORMÁTICA LTDA, é totalmente
                        vedada.
                    </p>

                    <h4>3. Política de Privacidade</h4>

                    <h5>3.1. Apresentação</h5>
                    <p>
                        Esta política descreve os tipos de informações que a Enterative Ltda coleta
                        de seus Usuários e Estabelecimentos e como elas são utilizadas. Ao utilizar
                        o Enterative você concorda com a utilização de suas informações pessoais e
                        entende que o objetivo do aplicativo é oferecer uma plataforma de interação
                        de Usuários e Estabelecimentos com objetivos de e-commerce, estas estarão
                        disponíveis para visualização e divulgação por meio de sua rede e outros
                        canais.
                    </p>
                    <p>
                        A Enterative Ltda pode coletar, gravar e utilizar, unilateralmente ou em
                        conexão com outros aplicativos, sites e parceiros quaisquer informações do
                        Usuário e/ou Estabelecimento, incluindo, mas não se limitando a, nome,
                        fotos, endereço, número de telefone, interesses, atividades, gênero
                        informado e idade.
                    </p>

                    <h5>3.2. Usuário</h5>
                    <p>
                        Para efetuar o cadastro no Aplicativo, é necessário o preenchimento de nome
                        completo, username, e-mail, senha e localidade. Alguns desses dados estarão
                        disponíveis para os outros usuários de sua rede, como nome, username e
                        localidade, sendo os demais dados de uso exclusivo do usuário e do
                        Enterative.
                    </p>
                    <p>
                        Ao efetuar o registro no Enterative, o Usuário pode comprar e ativar dos
                        melhores conteúdos digitais, nas modalidades Online (Voucher) e Cartão
                        Físico desde que em nenhuma dessas atividades e nas demais possíveis no
                        Aplicativo, haja desobediência à esta Política de Privacidade e Termos e
                        Condições de Uso, ou, ainda, à legislação vigente no País. Nesses casos, a
                        Enterative Ltda se reserva no direito de moderação ou veto do conteúdo
                        impróprio, armazenando as informações necessárias para quaisquer
                        procedimentos judiciais que possam vir a ocorrer.
                    </p>

                    <h5>3.3. Estabelecimentos</h5>
                    <p>
                        Os estabelecimentos podem ser cadastrados ou de domínio público. Aos de
                        domínio público, a Enterative Ltda se reserva no direito de fazer a gestão e
                        moderação de todo o conteúdo, podendo vetar aqueles que se mostrem
                        impróprios. Ao identificar um estabelecimento de domínio público como sendo
                        próprio, o responsável pelo estabelecimento solicitará à equipe da
                        Enterative Ltda a propriedade e gestão do perfil do estabelecimento, sendo
                        este liberado quando da comprovação da propriedade.
                    </p>
                    <p>
                        Para o cadastramento do Estabelecimento, serão necessários o nome, endereço,
                        telefone, faixa de preço, categoria, subcategoria, entre outros dados. Esses
                        dados estarão disponíveis para facilitar a busca do Usuário pelo
                        Estabelecimento, bem como classificá-los em rankings por categoria. A
                        Enterative Ltda se reserva no direito de vetar ou moderar qualquer conteúdo
                        que esteja em desacordo com a legislação vigente no País ou com a presente
                        Política de Privacidade e Termos de Uso.
                    </p>

                    <h5>3.4. Utilização das informações</h5>
                    <p>
                        A Enterative Ltda se resguarda no direito de gravar seu IP, tipo de
                        navegador, aparelho e operadora de celular, posição geográfica e outros
                        dados. Além de alguns dos usos específicos de informações descritos nesta
                        Política de Privacidade e Termos de Uso, podemos usar as informações que
                        recebemos para, entre outras finalidades:
                    </p>
                    <p>
                        (a) ajudá-lo a acessar de forma eficiente suas informações para que você não
                        tenha que digitá-las novamente durante sua visita ou a próxima vez que você
                        visitar o Enterative; (b) fornecer conteúdo personalizado e informações para
                        você e outras pessoas, que podem incluir anúncios on-line, envio de
                        mensagens ou outras formas de comercialização; (c) fornecer, melhorar,
                        testar e monitorar a eficácia do nosso serviço; (d) desenvolver e testar
                        novos produtos e recursos; (e) monitorar métricas como o número total de
                        visitantes, interações, tráfego e padrões demográficos; (f) diagnosticar ou
                        corrigir problemas de tecnologia; (g) atualizar automaticamente o aplicativo
                        Enterative no seu dispositivo.
                    </p>

                    <h5>3.5. Compartilhamento das Informações de Usuários e Estabelecimentos</h5>
                    <p>
                        O Enterative não divulga publicamente nem a terceiros suas informações de
                        modo que possam identificá-lo, mas pode fazê-lo de forma agregada no intuito
                        de realizar análises, estudos, ações comerciais, melhorias do sistema e por
                        força de ordem judicial.
                    </p>
                    <p>
                        Em caso de venda ou transferência de parte ou da totalidade da Enterative
                        Ltda ou de seus ativos para outra organização (por exemplo, no curso de uma
                        operação como uma fusão, aquisição, falência, dissolução, liquidação), as
                        informações como nome, endereço, e-mail, username e quaisquer outros
                        conteúdos coletados através deste serviço podem estar entre os itens
                        vendidos ou transferidos. Os Usuários e Estabelecimentos continuarão a
                        possuir seu conteúdo. O comprador ou cessionário terá de honrar os
                        compromissos que assumimos na presente Política de Privacidade e Termos de
                        Uso.
                    </p>

                    <h4>4. Sanções e Foro</h4>

                    <p>
                        O uso do Enterative de forma indevida em desacordo a esta Política de
                        Privacidade e Termos de Uso implicará a exclusão do cadastro do Usuário e/ou
                        Estabelecimento e a proibição da utilização dos serviços. Seus dados serão
                        preservados para uso das autoridades competentes, caso a Enterative Ltda
                        seja notificado ou acionado pela violação de direitos de terceiros
                        decorrente do mau uso do sistema.
                    </p>

                    <p>
                        O Usuário e/ou Estabelecimento se obrigam em indenizar a Enterative Ltda,
                        suas filiais, empresas controladas ou controladoras, diretores,
                        administradores, colaboradores, representantes e empregados por qualquer
                        perda, danos, responsabilização, reclamação ou demanda, por quaisquer
                        prejuízos devido a, ou resultantes da, sua utilização do Aplicativo.
                    </p>

                    <p>
                        Fica eleito o foro Central da Comarca de Belo Horizonte/MG, como competente
                        para dirimir quaisquer dúvidas oriundas da presente Política de Privacidade
                        e Termos de Uso, com exclusão de qualquer outro, por mais privilegiado que
                        seja. Ao finalizar o cadastro declaro ter lido, compreendido e concordado
                        integral e expressamente com a presente Política de Privacidade e Termos de
                        Uso.
                    </p>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <button
                            onClick={() => this.props.onHide()}
                            style={{
                                backgroundColor: "#411172",
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                                padding: "8px 16px",
                                cursor: "pointer",
                            }}
                        >
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
